export default __webpack_public_path__ + "static/media/arrow-left-white.5c0b93db.svg";